import React, { useEffect, useState } from 'react'

import {
  Btn,
  CustomCheckbox,
  CustomModal,
  InputNumeroInteiro,
  InputText,
} from '../../../../components'
import * as AreaHttp from '../../../../services/api/https/picking/picking-area.http'
import { errorHandler } from '../../../../services/util/error.service'
import { normalizeText, isValidAreaName, isDuplicateAreaName } from './AreaSeparacaoHook'

const INIT_AREA = {
  id: null,
  name: '',
  actived: true,
  tp_id: null,
  sequence: '',
}

export default function ModalAreaSeparacao({ selectedArea, visible, onHide, onResponse, existingAreas = [] }) {
  const [area, setArea] = useState({ ...INIT_AREA })
  const [isLoading, setIsLoading] = useState(false)

  useEffect(() => {
    selectedArea && setArea(selectedArea)
  }, [selectedArea])

  const onFormContentChange = (name, value) => {
    setArea(prev => {
      if (name === 'name' && typeof value === 'string') {
        value = normalizeText(value)
      }
      prev[name] = value
      return { ...prev }
    })
  }

  const onBtnSalvarClicked = async () => {

    const trimmedName = area.name.trim()

    if (!trimmedName) {
      onResponse('error', 'O nome da área é obrigatório')
      return
    }

    if (!isValidAreaName(trimmedName)) {
      onResponse('error', 'O nome da área deve conter apenas letras maiúsculas e números, sem acentuação')
      return
    }

    if (isDuplicateAreaName(trimmedName, existingAreas, area.id)) {
      onResponse('error', 'Já existe uma área com este nome')
      return
    }

    try {
      setIsLoading(true)
      const areaToSave = { ...area, name: trimmedName }
      const savedArea = await AreaHttp.saveArea(areaToSave)
      onResponse('success', savedArea)
    } catch (error) {
      onResponse('error', errorHandler(error))
    } finally {
      setIsLoading(false)
    }
  }

  return (
    <CustomModal header="Área de Separação" isVisible={visible} onClose={onHide}>
      <form className="p-grid">
        <div className="p-col-6">
          <InputText
            label="Área :"
            marginTop={10}
            value={area.name}
            onChange={value => onFormContentChange('name', value)}
          />
        </div>
        <div className="p-col-6">
          <InputNumeroInteiro
            label="Sequência :"
            marginTop={10}
            value={area.sequence}
            onChange={value => onFormContentChange('sequence', value)}
          />
        </div>
        <div className="p-col-6">
          <CustomCheckbox
            onChange={value => onFormContentChange('actived', value)}
            checked={area.actived}
          >
            Ativo
          </CustomCheckbox>
        </div>
        <div className="p-col-12">
          <Btn isLoading={isLoading} onClick={onBtnSalvarClicked}>
            Salvar
          </Btn>
        </div>
      </form>
    </CustomModal>
  )
}